import { useAuthStore } from '../../store/useAuthStore';
import { Navigate } from 'react-router-dom';

/**
 * RoleGuard – renders children only if the current user has one of the allowed roles.
 * Usage: <RoleGuard roles={['admin','manager']}><ManagerPage /></RoleGuard>
 */
export default function RoleGuard({ roles, children, fallback = null }) {
    const user = useAuthStore(s => s.user);

    if (!user) return null;

    if (!roles.includes(user.role)) {
        return fallback ?? <Navigate to="/contacts" replace />;
    }

    return children;
}
